import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { useSnackbar } from "notistack";
import axios from "axios";
import sh from "bundles/common/utils/sh";

// Follow / unfollow a company for the signed-in candidate.
// followed_company_ids is a string[] column, so ids are compared as strings.
const useFollowCompany = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const currentCandidate = useSelector((state) => state.current_candidate);
  const authenticityToken = useSelector((state) => state.authenticity_token);

  const isFollowed = (companyId) =>
    (currentCandidate?.followed_company_ids || []).map(String).includes(String(companyId));

  const toggleFollow = useCallback((companyId) => {
    if (!currentCandidate?.id) return;

    const currentIds = (currentCandidate.followed_company_ids || []).map(String);
    const cid = String(companyId);
    const updatedIds = currentIds.includes(cid)
      ? currentIds.filter((id) => id !== cid)
      : [...currentIds, cid];

    sh.put("update_followed_companies", {
      authenticity_token: authenticityToken,
      followed_company_ids: updatedIds,
    })
      .then((res) => {
        if (res.data) dispatch({ type: "UPDATE_CURRENT_CANDIDATE", payload: res.data });
      })
      .catch((err) => {
        if (axios.isCancel(err)) return;
        enqueueSnackbar(intl.formatMessage({ id: "failed_snack" }), { variant: "error" });
      });
  }, [currentCandidate, authenticityToken, dispatch, enqueueSnackbar, intl]);

  return { isFollowed, toggleFollow };
};

export default useFollowCompany;
